'use strict';

const SELECTORS = {
    contactModal: '#modalContact',
    contactIframe: '.js-contact-modal-iframe'
};

if ($(SELECTORS.contactModal).length && $(SELECTORS.contactIframe).length) {
    const $modal = $(SELECTORS.contactModal);
    const $iframe = $(SELECTORS.contactIframe);

    $modal.on('show.bs.modal', function () {
        const iframeUrl = $modal.attr('data-contact-iframe-url') || '';

        if (iframeUrl) {
            $iframe.attr('src', iframeUrl);
            $iframe.removeAttr('aria-hidden');
            $iframe.removeAttr('tabindex');
        }
    });

    $modal.on('hide.bs.modal', function () {
        $iframe.attr('src', '');
        $iframe.attr('aria-hidden', 'true');
        $iframe.attr('tabindex', '-1');
    });

    if (new URLSearchParams(window.location.search).get('contattaci') === 'form') {
        $modal.modal('show');
    }
}
